module.exports = __webpack_public_path__ + "templates/calendar-monthly_calendar.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/booking/templates/calendar-monthly_calendar.html
// module id = 5sXL
// module chunks = 1